import { useRef, useEffect } from "react";

export default function useTimer(callback, delay) {
  const timerRef = useRef(null);

  // Start the timer
  const startTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(callback, delay);
  };

  // Reset the timer
  const resetTimer = () => {
    startTimer();
  };

  // Clear the timer
  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return { startTimer, resetTimer, clearTimer };
}
